/* ============================================================
   PRISMAX — shared page interactions + direction switcher
   ============================================================ */
(function () {
  var html = document.documentElement;

  // ---- direction switcher (persisted) ----
  var STACK = { standard: 'Der Neue Standard', gloss: 'Prisma Gloss', spectrum: 'Spectrum' };
  function setDir(d) {
    if (!STACK[d]) return;
    html.setAttribute('data-dir', d);
    document.querySelectorAll('.seg button').forEach(function (b) {
      b.classList.toggle('active', b.dataset.d === d);
    });
    try { localStorage.setItem('prismax-dir', d); } catch (e) {}
  }
  var saved = null;
  try { saved = localStorage.getItem('prismax-dir'); } catch (e) {}
  if (saved) setDir(saved);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.seg button');
    if (b) setDir(b.dataset.d);
  });

  // ---- mobile nav ----
  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav-burger')) { document.querySelector('.mnav') && document.querySelector('.mnav').classList.add('open'); }
    if (e.target.closest('.mnav-close') || e.target.closest('.mnav li a')) { document.querySelector('.mnav') && document.querySelector('.mnav').classList.remove('open'); }
  });

  // ---- product carousel tabs ----
  // Each tab owns a track (data-panel). Arrows and the progress bar always act on
  // whichever track is currently visible.
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var tabBtns = car.querySelectorAll('.tabs button');
    var tracks = car.querySelectorAll('.carousel-track');
    var bar = car.querySelector('.carousel-foot .bar');
    if (!tracks.length) return;

    function active() {
      for (var i = 0; i < tracks.length; i++) { if (!tracks[i].hidden) return tracks[i]; }
      return tracks[0];
    }
    function paint() {
      var track = active();
      if (!bar || !track) return;
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      var vis = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      bar.style.width = Math.min(1, Math.max(0.12, vis)) * 100 + '%';
      bar.style.left = p * (100 - Math.min(100, Math.max(12, vis * 100))) + '%';
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.tab;
        if (idx === undefined) return;
        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        tracks.forEach(function (t) { t.hidden = t.dataset.panel !== idx; });
        var t = active();
        if (t) t.scrollTo({ left: 0, behavior: 'auto' });
        paint();
      });
    });

    function step() {
      var track = active();
      var c = track && track.querySelector('.pcard');
      return c ? c.getBoundingClientRect().width + 20 : 320;
    }
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    if (next) next.addEventListener('click', function () { active().scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { active().scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    tracks.forEach(function (t) { t.addEventListener('scroll', paint, { passive: true }); });
    window.addEventListener('resize', paint, { passive: true });
    paint();
  });

  // ---- PDP gallery ----
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.main .ph .ph-label');
    var thumbs = g.querySelectorAll('.thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (main && t.dataset.label) main.textContent = t.dataset.label;
      });
    });
  });

  // ---- variant pills ----
  document.querySelectorAll('[data-variant]').forEach(function (group) {
    var out = document.querySelector(group.dataset.variant);
    group.querySelectorAll('.pill-opt').forEach(function (pill) {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.pill-opt').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        if (out) out.textContent = pill.dataset.val || pill.textContent.trim();
      });
    });
  });

  // ---- quantity ----
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var val = q.querySelector('.qv');
    var n = 1;
    q.querySelector('[data-inc]').addEventListener('click', function () { n++; val.textContent = n; });
    q.querySelector('[data-dec]').addEventListener('click', function () { if (n > 1) { n--; val.textContent = n; } });
  });

  // ---- toggles ----
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.toggle');
    if (t) t.classList.toggle('on');
  });

  // ---- FAQ accordion ----
  document.querySelectorAll('.faq .q').forEach(function (q) {
    q.addEventListener('click', function () {
      var qa = q.closest('.qa');
      var open = qa.classList.contains('open');
      qa.parentElement.querySelectorAll('.qa').forEach(function (x) { x.classList.remove('open'); });
      if (!open) qa.classList.add('open');
    });
  });

  // ---- sticky add-to-cart ----
  var sticky = document.querySelector('.sticky-buy');
  var anchor = document.querySelector('[data-buybox]');
  if (sticky && anchor) {
    window.addEventListener('scroll', function () {
      var r = anchor.getBoundingClientRect();
      if (r.bottom < 80) sticky.classList.add('show');
      else sticky.classList.remove('show');
    }, { passive: true });
  }

  // ---- cart count bump on add ----
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-add]')) {
      document.querySelectorAll('.cc').forEach(function (cc) {
        cc.textContent = (parseInt(cc.textContent || '0', 10) + 1);
        cc.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 300 });
      });
    }
  });

  // ============================================================
  //  MOTION LAYER
  // ============================================================
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- press / logo strip → infinite marquee ----
  (function () {
    document.querySelectorAll('.press .logos').forEach(function (logos) {
      if (logos.dataset.marquee) return;
      logos.dataset.marquee = '1';
      var wrap = document.createElement('div');
      wrap.className = 'marquee';
      var track = document.createElement('div');
      track.className = 'marquee-track';
      var inner = document.createElement('span');
      inner.style.display = 'inline-flex'; inner.style.alignItems = 'center'; inner.style.gap = getComputedStyle(logos).gap || '32px';
      inner.innerHTML = logos.innerHTML;
      var copy = inner.cloneNode(true);
      copy.style.paddingLeft = inner.style.gap;
      track.appendChild(inner); track.appendChild(copy);
      wrap.appendChild(track);
      logos.replaceWith(wrap);
      if (!reduce) requestAnimationFrame(function () {
        var w = inner.scrollWidth; if (w > 0) track.style.animationDuration = Math.max(22, Math.round(w / 55)) + 's';
      });
    });
  })();

  // Scroll-reveal removed on purpose. Fading in every chip, row and crumb reads as a
  // generic AI template. Motion is reserved for hover and deliberate interactions.

  // ---- lift WhatsApp FAB above sticky buy bar ----
  (function () {
    var sb = document.querySelector('.sticky-buy');
    if (!sb) return;
    var obs = new MutationObserver(function () {
      document.body.classList.toggle('wa-lift', sb.classList.contains('show'));
    });
    obs.observe(sb, { attributes: true, attributeFilter: ['class'] });
  })();
})();

/* ---------------------------------------------------------------------------
   Mobile rails (client change sheet 20 Aug, tab 3 item 19)
   "These Products should be a Carousel rather than a whole list as this makes it
    unnecessarily lengthy ... arrow on side and tap and scroll behaviour in Loop.
    Same with Ceramic PPF."

   The rail itself is pure CSS (flex + scroll-snap under 880px), so tap-and-scroll
   works with this script absent. This only wires the arrows and the loop, and it
   no-ops above the breakpoint where the grid is still a grid.
--------------------------------------------------------------------------- */
(function () {
  var arrowSets = document.querySelectorAll('[data-px-rail-arrows]');
  if (!arrowSets.length) return;

  arrowSets.forEach(function (arrows) {
    var scope = arrows.closest('section') || document;
    var rail = scope.querySelector('[data-px-rail]');
    if (!rail) return;

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 14) || 14;
      return first.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }
    function go(dir) {
      var max = maxScroll();
      if (max <= 1) return;                       // grid mode, nothing to scroll
      var x = rail.scrollLeft;
      var next = x + dir * step();
      // loop, as asked
      if (dir > 0 && x >= max - 2) next = 0;
      else if (dir < 0 && x <= 2) next = max;
      rail.scrollTo({ left: next, behavior: 'smooth' });
    }

    var prev = arrows.querySelector('[data-rail-prev]');
    var next = arrows.querySelector('[data-rail-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  });
})();
